<section class="additional-properties">
  <div class="section-header">
    <h4>Additional company properties</h4>
    <p class="help-text">Object: Company @if (portalId) { · HubSpot portal {{ portalId }} }</p>
  </div>
  <mat-form-field appearance="outline" class="action-picker">
    <mat-label>Action</mat-label>
    <mat-select [value]="selectedAction" (selectionChange)="selectedAction = $event.value" [disabled]="disabled">
      <mat-option value="create">Create company</mat-option>
      <mat-option value="update">Update company</mat-option>
    </mat-select>
  </mat-form-field>
  <p class="help-text">
    @if (selectedAction === 'create') {
      Fill missing values on single and batch company creation. Mapped values take priority.
    } @else {
      Fill fields confirmed empty in HubSpot during single and batch enrichment updates. Existing values and explicit clears are preserved.
    }
  </p>
  @if (connectionChanged) {
    <div class="connection-notice" role="alert">
      <p>The HubSpot connection has changed. Review these properties before saving them for the current connection.</p>
      <button mat-stroked-button type="button" (click)="useCurrentConnection()" [disabled]="disabled || !propertiesReady">Use current connection</button>
    </div>
  }
  @if (propertiesError) {
    <p class="property-error" role="alert">Company properties are unavailable. Retry loading settings before adding or saving values.</p>
  }
  <div class="property-rows">
    @for (row of rows().controls; track row; let index = $index) {
      <div class="property-row" [formGroup]="row">
        <mat-form-field appearance="outline">
          <mat-label>HubSpot property name</mat-label>
          <input matInput formControlName="propertyName" [matAutocomplete]="propertyOptions" autocomplete="off"
                 [attr.aria-describedby]="selectedAction + '-additional-error-' + index" />
          <mat-autocomplete #propertyOptions="matAutocomplete">
            @for (property of suggestions(row.controls.propertyName.value); track property.name) {
              <mat-option [value]="property.name">{{ property.label }} ({{ property.name }})</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Value</mat-label>
          @if (property(row.controls.propertyName.value)?.type === 'enumeration') {
            <mat-select formControlName="value">
              @for (option of property(row.controls.propertyName.value)?.options || []; track option.value) {
                @if (!option.hidden) { <mat-option [value]="option.value">{{ option.label }} ({{ option.value }})</mat-option> }
              }
            </mat-select>
          } @else if (property(row.controls.propertyName.value)?.type === 'bool') {
            <mat-select formControlName="value"><mat-option value="true">true</mat-option><mat-option value="false">false</mat-option></mat-select>
          } @else {
            <input matInput formControlName="value" maxlength="4000" autocomplete="off"
                   [attr.aria-describedby]="selectedAction + '-additional-error-' + index" />
          }
        </mat-form-field>
        <button mat-icon-button type="button" class="remove-property" (click)="remove(index)" [disabled]="disabled"
                [attr.aria-label]="'Remove ' + (row.controls.propertyName.value || 'property')"><mat-icon>delete_outline</mat-icon></button>
        @if (rowError(selectedAction, index); as error) {
          <p class="property-error" role="alert" [id]="selectedAction + '-additional-error-' + index">{{ error }}</p>
        }
      </div>
    } @empty {
      <p class="help-text">No additional properties for this action. Existing behavior is unchanged.</p>
    }
  </div>
  <button mat-stroked-button type="button" (click)="add()" [disabled]="disabled || !propertiesReady || !!propertiesError || rows().length >= 50">
    <mat-icon>add</mat-icon>Add property
  </button>
  <p class="help-text">Save settings to apply these values to future writes. Saving does not start a sync. Removing a row does not clear values already in HubSpot.</p>
</section>
